// EO 2026 Editorial Navigation — stable open/close, no viewport jump
(() => {
  const mq = window.matchMedia('(min-width: 1000px)');
  let activeDrawer = null;

  const getHeaderBottom = () => {
    const headerSection = document.querySelector('.shopify-section--header');
    if (!headerSection) return 0;
    return Math.max(0, Math.round(headerSection.getBoundingClientRect().bottom));
  };

  const placeDrawersAtBodyRoot = () => {
    document.querySelectorAll('.eo-nav-drawer').forEach((drawer) => {
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    });
  };

  const positionDrawer = (drawer) => {
    if (!drawer) return;
    drawer.style.setProperty('--eo-nav-top', getHeaderBottom() + 'px');
  };

  const unlockPage = () => {
    document.documentElement.classList.remove('eo-nav-open');
  };

  const lockPage = () => {
    document.documentElement.classList.add('eo-nav-open');
  };

  const closeDrawer = (drawer, restoreFocus = true) => {
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockPage();

    if (restoreFocus) {
      const triggerId = drawer.dataset.triggerId;
      if (triggerId) document.getElementById(triggerId)?.focus();
    }

    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 180);

    if (activeDrawer === drawer) activeDrawer = null;
  };

  const openDrawer = (drawer, trigger) => {
    if (!drawer || !mq.matches) return;

    if (activeDrawer && activeDrawer !== drawer) {
      activeDrawer.classList.remove('is-open');
      activeDrawer.setAttribute('aria-hidden', 'true');
      activeDrawer.hidden = true;
    }

    positionDrawer(drawer);
    drawer.hidden = false;
    drawer.dataset.triggerId = trigger.id || '';
    drawer.setAttribute('aria-hidden', 'false');

    // Force layout once so panel + overlay start from the same visual frame.
    void drawer.offsetWidth;

    drawer.classList.add('is-open');
    lockPage();
    activeDrawer = drawer;
  };

  const toggleDrawer = (drawer, trigger) => {
    if (drawer?.classList.contains('is-open')) {
      closeDrawer(drawer);
    } else {
      openDrawer(drawer, trigger);
    }
  };

  const init = () => {
    placeDrawersAtBodyRoot();
    document.documentElement.classList.add('eo-editorial-ready');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-eo-menu-trigger]');

    if (trigger && mq.matches) {
      const targetId = trigger.getAttribute('aria-controls');
      const drawer = targetId ? document.getElementById(targetId) : null;

      if (drawer) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const details = trigger.closest('details');
        if (details) details.removeAttribute('open');

        if (!trigger.id) {
          trigger.id = 'eo-menu-trigger-' + targetId.replace('eo-nav-drawer-', '');
        }

        toggleDrawer(drawer, trigger);
      }
      return;
    }

    const close = event.target.closest('[data-eo-nav-close], [data-eo-nav-overlay]');
    if (close) {
      event.preventDefault();
      closeDrawer(close.closest('.eo-nav-drawer'));
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeDrawer) {
      event.preventDefault();
      closeDrawer(activeDrawer);
    }
  });

  window.addEventListener('resize', () => {
    if (activeDrawer) positionDrawer(activeDrawer);
  }, { passive: true });

  mq.addEventListener?.('change', (event) => {
    if (!event.matches && activeDrawer) closeDrawer(activeDrawer, false);
  });
})();


// EO homepage editorial commerce rails
document.addEventListener('click', (event) => {
  const next = event.target.closest('[data-eo-rail-next]');
  const prev = event.target.closest('[data-eo-rail-prev]');
  if (!next && !prev) return;

  const wrap = event.target.closest('.eo-commerce-rail__products-wrap');
  const scroller = wrap?.querySelector('[data-eo-rail-scroll]');
  if (!scroller) return;

  const card = scroller.querySelector('.eo-commerce-product');
  const step = card ? card.getBoundingClientRect().width + 16 : scroller.clientWidth * .8;

  scroller.scrollBy({
    left: next ? step : -step,
    behavior: 'smooth'
  });
});


// EO collection discovery — local filtering for fully loaded pilot collections
(() => {
  const normalize = (value = '') =>
    value.toLocaleLowerCase('pt-BR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

  const updateCollectionSearch = (input) => {
    const scope = input.closest('.shopify-section--main-collection') || document;
    const query = normalize(input.value);
    const cards = [...scope.querySelectorAll('.product-list > .product-card')];
    const clear = scope.querySelector('[data-eo-collection-search-clear]');
    const status = scope.querySelector('[data-eo-collection-search-status]');
    let visible = 0;

    cards.forEach((card) => {
      const title = normalize(card.querySelector('.product-title')?.textContent || '');
      const handle = normalize(card.getAttribute('handle') || '');
      const match = !query || title.includes(query) || handle.includes(query);
      card.hidden = !match;
      if (match) visible += 1;
    });

    if (clear) clear.hidden = !query;

    if (status) {
      if (!query) {
        status.textContent = '';
      } else if (visible === 0) {
        status.textContent = 'Nenhum produto encontrado nesta coleção.';
      } else {
        status.textContent = visible === 1 ? '1 produto encontrado.' : visible + ' produtos encontrados.';
      }
    }
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-eo-collection-search]');
    if (input) updateCollectionSearch(input);
  });

  document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-eo-collection-search-clear]');
    if (!clear) return;
    const scope = clear.closest('[data-eo-collection-discovery]');
    const input = scope?.querySelector('[data-eo-collection-search]');
    if (!input) return;
    input.value = '';
    updateCollectionSearch(input);
    input.focus();
  });
})();
